import React, { useCallback, useEffect, useMemo } from "react";
import { Button, ButtonGroup, ToggleButton } from "react-bootstrap";
import { X } from "react-feather";

const BooleanFilter = ({
  column: { filterValue, setFilter, filterOptions },
}) => {
  const filterPrefix = "$BOOL=";

  // Remember the options as they can come from a promise
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (!filterOptions) {
      console.log("❌ No filter options");
      return null;
    }

    let isMounted = true; // prevent updates after unmount

    const loadOptions = async () => {
      setLoading(true);
      try {
        // Handle array directly
        if (Array.isArray(filterOptions)) {
          if (isMounted) setOptions(filterOptions);
        }
        // Handle promise
        else if (filterOptions instanceof Promise) {
          const result = await filterOptions;
          if (isMounted) setOptions(result);
        }
        // Handle async function
        else if (typeof filterOptions === "function") {
          const result = await filterOptions();
          if (isMounted) setOptions(result);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadOptions();

    return () => {
      isMounted = false;
    };
  }, [filterOptions]);

  const parseFilterValue = useCallback(() => {
    var parseResult = null;

    if (
      filterValue &&
      typeof filterValue === "string" &&
      filterValue.startsWith(filterPrefix)
    ) {
      var rightSide = filterValue.substring(filterPrefix.length);

      parseResult = rightSide;
    }

    return parseResult;
  }, [options, filterValue]);

  var booleanValue = useMemo(() => parseFilterValue(), [parseFilterValue]);

  return (
    <React.Fragment>
      {!loading && (
        <React.Fragment>
          <ButtonGroup>
            {filterOptions.map((opt, idx) => (
              <ToggleButton
                key={idx}
                id={`bool-filter-${idx}`}
                type="radio"
                variant="outline-light"
                name="bool-filter"
                value={opt.value}
                title={opt.title}
                checked={booleanValue === opt.value}
                onChange={(e) => {
                  setFilter(filterPrefix + e.currentTarget.value);
                }}
              >
                {opt.label}
              </ToggleButton>
            ))}
          </ButtonGroup>
          <Button
            variant=""
            className="p-0 m-0"
            onClick={() => {
              setFilter("");
            }}
          >
            <X />
          </Button>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default BooleanFilter;
